<template>
  <div id="contact">
    <a-row>
      <a-col :sm="{ span: 24 }" :md="{ span: 6 }" :xl="{ span: 6 }">
        <a-card>
          <a-statistic
            title="Feedback"
            :value="11.28"
            :precision="2"
            suffix="%"
            :value-style="{ color: '#3f8600' }"
            style="margin-right: 50px"
          >
            <template #prefix>
              <a-icon type="arrow-up" />
            </template>
          </a-statistic>
        </a-card>
      </a-col>
      <a-col :sm="{ span: 24 }" :md="{ span: 18 }" :xl="{ span: 18 }">
        gene详细页面
      </a-col>
    </a-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      location: {
        lng: 113.26229,
        lat: 23.115563,
      },
      zoom: 12.8,
      addressKeyword: "沿江西路107号",
    };
  },
};
</script>
<style scpoed></style>
